// ItemIssuePage.jsx
import {Navbar,Footer,Sidebar} from '../medicalcomponents';
import React, { useEffect, useState, useRef  } from "react";
import axios from "axios";
import configData from "../config.json";
import { format } from 'date-fns';
import { useReactToPrint } from "react-to-print";
import Select from "react-select";

// Example props: none required — it fetches itemList from backend
export default function ItemReceiveCom() {

    const componentRef = useRef(null);

  const [itemList, setItemList] = useState([]); // {id, name, stockQty}
  const [filterItemList, setFilterItemList] = useState([]);
  const [itemId, setItemId] = useState("");
  const [qty, setQty] = useState("");
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemSearch,setItemSearch]=useState("");

  
  const [mrrNo, setMRRNo] = useState("");
  const [price, setPrice] = useState("");
  const [mrrDate, setMRRDate] = useState("");

  const [voucher, setVoucher] = useState([]);
  

  useEffect(() => {
    const getAssetData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/itemData/${localStorage.getItem('branchID')}`);
          setItemList(response.data);
          setFilterItemList(response.data);
    };
    getAssetData();
  }, []);

  const resetInputs = () => {
    setItemId("");
    setQty(0);
    setPrice(0);
  };

  const handleAddToGrid = () => {
    if (!itemId) return alert("Select an item.");
    if (!qty || Number(qty) <= 0) return alert("Enter valid quantity.");

    const selected = itemList.find((i) => String(i.id) === String(itemId));
    if (!selected) return alert("Invalid item selected.");

    // Add row (simple push, duplicates allowed in this simple version)
    setGridData((prev) => [
      ...prev,
      {
        itemId: selected.id,
        itemName: selected.itemName,
        qty: Number(qty),
        price: price,
      },
    ]);

    resetInputs();
  };

  const handleDeleteRow = (index) => {
    setGridData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditRow = (index) => {
    // simple inline edit flow: load row into inputs and remove row
    const row = gridData[index];
    setItemId(row.itemId);
    setQty(row.qty);
    // setRemarks(row.remarks);
    setGridData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmitFinal = async () => {
    if (gridData.length === 0) return alert("No items to submit.");

    const payload = {
      mrrDate: format(mrrDate,'yyyy-MM-dd'),
      mrrNo:mrrNo,
      items: gridData,
      branchID:localStorage.getItem('branchID'),  
    };

    try {
        setLoading(true);
        let res=await axios.post(configData.SERVER_URL+`/mrrEntry`,payload);
        if(res.status===200){
            alert(res.data.message);
            setGridData([]);
            setVoucher(res.data.voucher.data);
        }
    } catch (err) {
      console.error(err);
      alert("Save failed: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  const filterItem=(e)=>{

    const value = e.target.value.toLowerCase();   
    setItemSearch(value);

    const updatedList = itemList.filter(items =>
        items.itemCode?.toLowerCase().includes(value) ||
        items.itemName?.toLowerCase().includes(value) ||
        items.groupName?.toLowerCase().includes(value)
    );
    setFilterItemList(updatedList);
    }

    const printDiv = () => {
        const printContent = document.getElementById("print-area").innerHTML;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent;
        window.print();
        document.body.innerHTML = originalContent;
        window.location.reload();
    };

  return (
    <>
      <div className="well">
        <div className="card">

      <div className="card well">
        <div className="card-body bg-info" style={{padding: "20px", borderRadius: "10px"}}>
            <div style={{ width: 300 }}>
                <label>MRR No</label>
                <input type="text" className="form-control" name="mrrNo" id="mrrNo"   value={mrrNo} onChange={(e)=>setMRRNo(e.target.value)}></input>
            </div>

            <div style={{ width: 300 }}>
                <label>MRR Date</label>
                <input type="date" className="form-control" name="mrrDate" id="mrrDate"   value={mrrDate} onChange={(e)=>setMRRDate(e.target.value)}></input>
            </div>

        </div>
      </div>
      
      <div className="card well">
        <div className="card-body bg-light" style={{padding: "20px", borderRadius: "10px"}}>
            <div className='row'>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 12 }}>
                <div style={{ flex: 2 }}>
                <label>Item</label>
                {/* <input type="text" style={{width:200}} className="form-control" name="itemSearch" id="itemSearch" placeholder="Search by name" value={itemSearch} onChange={(e)=>filterItem(e)}></input>
                <select className="form-control" value={itemId} onChange={(e) => setItemId(e.target.value)}>
                <option value="">-- Select Item --</option>
                {filterItemList.map((it) => (
                <option key={it.id} value={it.id}>
                {it.itemCode+" : "+it.itemName+" -> "+it.groupName} {it.stockQty !== undefined ? `(Stock: ${it.stockQty})` : ""}
                </option>
                ))}
                </select> */}
                <Select options={filterItemList.map(it => ({ value: it.id, label: (it.itemCode+' : '+it.itemName+' -> '+(Number(it.openingStock) + Number(it.mrr_qty) - Number(it.issueQty))) }))} isSearchable 
                  placeholder="Select Items..."
                  onChange={(selectedOption) => {
                  if (selectedOption) {
                  setItemId(selectedOption.value);   // store ID
                  } else {
                  setItemId(null);
                  }
                  }}
                  />
            </div>


            <div style={{ width: 120 }}>
                <label>Price</label>
                <input className="form-control" type="number" min="0" value={price} onChange={(e) => setPrice(e.target.value)} />
            </div>

            <div style={{ width: 120 }}>
                <label>Qty</label>
                <input className="form-control" type="number" min="1" value={qty} onChange={(e) => setQty(e.target.value)} />
            </div>

            <div style={{textAlign:'right'}}>
                <button className="btn btn-success" onClick={handleAddToGrid} style={{ marginBottom: 4 }}> Add </button>
            </div>
            </div>

            </div>
        </div>
      </div>

      <table class="table table-info table-hover table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Price</th>
            <th>Qty</th>
            
            <th style={{ width: 150 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {gridData.length === 0 ? (
            <tr>
              <td colSpan={5} style={{ textAlign: "center" }}>
                No items added
              </td>
            </tr>
          ) : (
            gridData.map((r, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{r.itemName}</td>
                <td>{r.price}</td>
                <td>{r.qty}</td>
   
                <td>
                  <button className="btn btn-sm btn-primary mr-2" onClick={() => handleEditRow(i)}>Edit</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDeleteRow(i)}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div style={{ display: "flex", gap: 12 }}>
        <button className="btn btn-primary" onClick={handleSubmitFinal} disabled={loading}>
          {loading ? "Saving..." : "Submit All"}
        </button>
        <button className="btn btn-secondary" onClick={() => setGridData([])} disabled={loading}>
          Clear Grid
        </button>
      </div>
        </div>
        {
        voucher && voucher.length>0 &&(
        <div className="card" id="print-area" >
            <div className='card-header bg-info text-center'>
                <h2>Receive Details</h2> 
                <button onClick={printDiv}>Print</button> 
            </div>
            
        <table class="table table-info table-hover table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Price</th>
            <th>Qty</th>
          </tr>
        </thead>
        <tbody>
            {
            voucher.map((r, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{r.itemName+" : "+r.itemCode}</td>
                <td>{r.mrr_price}</td>
                <td>{r.mrr_qty}</td>
              </tr>
            ))
        }
        </tbody>
        </table>

        </div>
        )
        }
      </div>       
    </>
  );
}
